import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`キーボードのれんしゅうをしよう！`}</h2>
    <ProjectCard title="ローマ字表" link="https://arschool.co.jp/blog/wp-content/uploads/2020/05/0b0da253b100b715a43bb24ef61cd529.pdf" bg="linear-gradient(to right, #48b1bf 0%, #06beb6 100%)" mdxType="ProjectCard">
このひょうを　がめんの　よこに　だしておくと　べんり！
    </ProjectCard>
    <ProjectCard title="めざせ！タイピングマスター - FMVキッズ : 富士通パソコン" link="https://azby.fmworld.net/kids/typing/" bg="linear-gradient(to right, #48b1bf 0%, #06beb6 100%)" mdxType="ProjectCard">
ふじつうというかいしゃが　つくった　タイピングのれんしゅうが　できるページです。すこし　下に　スクロールして　きほんコースから　じゅんばんに　チャレンジするといいよ。
    </ProjectCard>
    <ProjectCard title="こどもタイピング | タイピング練習の「マイタイピング」" link="https://typing.twi1.me/game/3880" bg="linear-gradient(to right, #48b1bf 0%, #06beb6 100%)" mdxType="ProjectCard">
みぎがわに　いろいろな　タイピングの　かだいがあるよ。うたを　タイピングするものとか　いろいろあるので　ちゃれんじしてね
    </ProjectCard>
    <ProjectCard title="【寿司打】WebGL版" link="http://typingx0.net/sushida/" bg="linear-gradient(to right, #48b1bf 0%, #06beb6 100%)" mdxType="ProjectCard">
ねだんが　たかいコースほど　むずかしくなるよ！たくさんうてば、おとくに　おすしを　たべられる？！
    </ProjectCard>
    <h2>{`インターネットででのマナーについてかんがえよう！`}</h2>
    <ProjectCard title="教えて！なるほど！インターネット｜進研ゼミ小学講座の会員サイト【チャレンジウェブ】" link="https://sgaku.benesse.ne.jp/sho/all/others/oshiete/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
インターネットでおきるじけんについて　マンガふうに　よむことができるよ
    </ProjectCard>
    <h2>{`プログラミングにチャレンジ`}</h2>
    <ProjectCard title="ビスケット viscuit | コンピュータは粘土だ!!" link="https://www.viscuit.com/" bg="linear-gradient(to right, #333333 0%, #dd1818 100%)" mdxType="ProjectCard">
じぶんで　かいた　えが　ふしぎな　うごきをするよ。このよこの　リンクから　かいせつの　ページをよむといいよ。
    </ProjectCard>
    <ProjectCard title="ビスケット レシピ | すいぞくかんをつくろう！" link="https://kidsc2.org/recipes/15/chapters" bg="linear-gradient(to right, #333333 0%, #dd1818 100%)" mdxType="ProjectCard">
じぶんで　かいた　えが　ふしぎな　うごきをするよ。このよこの　リンクから　かいせつの　ページをよむといいよ。
    </ProjectCard>
    <ProjectCard title="CodeMonkey" link="https://app.codemonkey.com/challenges/0" bg="linear-gradient(to right, #333333 0%, #dd1818 100%)" mdxType="ProjectCard">
This project is my entry to Adobe's #ChallengeYourPerspective contest.
    </ProjectCard>
    <ProjectCard title="HOUROFCODE" link="https://hourofcode.com/jp/learn" bg="linear-gradient(to right, #333333 0%, #dd1818 100%)" mdxType="ProjectCard">
This project is my entry to Adobe's #ChallengeYourPerspective contest.
    </ProjectCard>
    <ProjectCard title="プログラミン | 文部科学省" link="https://www.mext.go.jp/programin/" bg="linear-gradient(to right, #333333 0%, #dd1818 100%)" mdxType="ProjectCard">
This project is my entry to Adobe's #ChallengeYourPerspective contest.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      